<template>
  <span class="e-input-group e-control-wrapper">
      <input v-model="column" :data-validate="data.column.dataValidate" :name="data.column.field" :id="`grid_${data.column.uid}_${data.column.index}${data.column.field}`" 
        class="e-field e-input e-defaultcell e-control e-textbox e-lib" :data-id="data.id" :data-regex-message="$t('widget.fieldInvalid')" :data-required-message="$t('widget.fieldRequired')" :maxlength="data.column.maxlength">
    </span>
    
</template>

<script>
export default {
  name: "columnEditTemplate",
  props: {
  },
};

</script>

<style>
</style>